module.exports = __webpack_public_path__ + "assets/details-liquidity.47f99932.svg";